import { useCallback, useContext, useRef } from 'react'
import type { MarkViewProps } from '@tiptap/core'
import type { MarkViewRendererProps } from '@tiptap/react'
import { ReactMarkViewContext } from '@tiptap/react'
import { useComplianceDocumentManifestContextOptional } from '@/features/compliance-studio/machinery-directive/context/ComplianceDocumentManifestContext'
import { DismissibleComplianceMarkShell } from '../dismissible-compliance-mark-shell'
import { removeMark } from '../remove-mark-from-mark-view'
import { MANUAL_INSTRUCTION_MARK } from './manual-instruction-mark'

export function ManualInstructionMarkView(props: MarkViewRendererProps) {
  const instruction = props.mark?.attrs?.instruction || ''
  const manifestContext = useComplianceDocumentManifestContextOptional()
  const dismissLabel = manifestContext
    ? manifestContext.getDismissAriaLabel()
    : 'Dismiss notice'
  const { markViewContentRef } = useContext(ReactMarkViewContext)
  const hostRef = useRef<HTMLSpanElement | null>(null)
  const setHostRef = useCallback(
    (element: HTMLSpanElement | null) => {
      hostRef.current = element
      markViewContentRef(element)
    },
    [markViewContentRef]
  )

  const handleDismiss = () => {
    const host = hostRef.current
    if (!host) {
      return
    }
    removeMark(MANUAL_INSTRUCTION_MARK, props as MarkViewProps, host)
  }

  return (
    <DismissibleComplianceMarkShell
      variant='blue'
      hostRef={setHostRef}
      dismissLabel={dismissLabel}
      onDismiss={handleDismiss}
      fullWidth
    >
      <span
        className='block w-full text-sm leading-relaxed text-blue-950 dark:text-blue-100'
        data-manual-instruction=''
        data-instruction={instruction ? instruction : undefined}
        title={instruction}
        aria-label={instruction}
      >
        {instruction}
      </span>
    </DismissibleComplianceMarkShell>
  )
}
